var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 12C6.25 11.5858 6.58579 11.25 7 11.25L17 11.25C17.4142 11.25 17.75 11.5858 17.75 12C17.75 12.4142 17.4142 12.75 17 12.75L7 12.75C6.58579 12.75 6.25 12.4142 6.25 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46967 12.5304C5.17678 12.2375 5.17678 11.7626 5.46967 11.4697L8.29967 8.63975C8.59256 8.34686 9.06744 8.34686 9.36033 8.63975C9.65322 8.93264 9.65322 9.40752 9.36033 9.70041L7.06066 12.0001L9.36033 14.2997C9.65322 14.5926 9.65322 15.0675 9.36033 15.3604C9.06744 15.6533 8.59256 15.6533 8.29967 15.3604L5.46967 12.5304Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6396 15.3604C14.3467 15.0675 14.3467 14.5926 14.6396 14.2997L16.9393 12.0001L14.6396 9.70041C14.3467 9.40752 14.3467 8.93264 14.6396 8.63975C14.9325 8.34686 15.4074 8.34686 15.7003 8.63975L18.5303 11.4697C18.8231 11.7626 18.8231 12.2375 18.5303 12.5304L15.7003 15.3604C15.4074 15.6533 14.9325 15.6533 14.6396 15.3604Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.45b6f65b.svg";
export { ForwardRef as ReactComponent };